import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import DOMPurify from 'dompurify';
import './AdminFeedback.css';
import privateAxios from '../../utils/axios/privateAxios';
import moment from 'moment';

const AdminFeedback = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [feedback, setFeedback] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFeedback = async () => {
      try {
        const response = await privateAxios.get(`/private/admin-feedback/${id}`);
        setFeedback(response.data.feedback);
      } catch (error) {
        console.error('Error fetching feedback', error);
      } finally {
        setLoading(false);
      }
    };

    fetchFeedback();
  }, [id]);

  if (loading) return <div className="admin-feedback-loading">Loading...</div>;

  if (!feedback) return <div className="admin-feedback-error">Feedback not found.</div>;

  return (
    <div className="admin-feedback">
      <div className="admin-feedback-header">
        <h1>{feedback.title}</h1>
        <p className="admin-feedback-meta">Username: {feedback.createdBy?.email}</p>
        <p className="admin-feedback-meta">
          By: {feedback.createdBy?.firstname} {feedback.createdBy?.lastname} | Created: {moment(feedback.createdAt).format('MMMM DD, YYYY')}
        </p>
      </div>

      {feedback.imageUrl && (
        <div className="admin-feedback-image-wrapper">
          <img src={feedback.imageUrl} alt="Feedback" />
        </div>
      )}

      <div
        className="admin-feedback-content"
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(feedback.content) }}
      ></div>

      <div className="admin-feedback-actions">
        <button onClick={() => navigate('/admin-feedbacks')}>Back to Feedbacks</button>
      </div>
    </div>
  );
};

export default AdminFeedback;
